module.exports = __webpack_public_path__ + "static/media/rigThinCompressed.345648f0.jpg";